import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-essentials-skeleton-paginator',
  templateUrl: './essentials-skeleton-paginator.component.html',
  styleUrls: ['./essentials-skeleton-paginator.component.scss']
})
export class EssentialsSkeletonPaginatorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
